import { Route } from 'next';

type ItemType = {
  href: Route,
  label: string
}

export const contactData: {
  email: ItemType,
  careers: ItemType,
  press: ItemType,
  phone: ItemType,
} = {
  email: {
    href: 'mailto:info@getprimary.com',
    label: 'info@getprimary.com',
  },
  // Hiring goes to its own inbox, deliberately kept off the general one.
  careers: {
    href: 'mailto:careers@primary.ai',
    label: 'careers@primary.ai',
  },
  // Journalists and analysts reach the PR team here, not the general inbox.
  press: {
    href: 'mailto:press@primary.ai',
    label: 'press@primary.ai',
  },
  phone: {
    href: 'tel:+8008979066',
    label: '(800) 897 - 9066',
  },
};

/** Company profiles, shared by the footer and any page that links out to them. */
export const socialData: {
  linkedin: { href: string; label: string },
  x: { href: string; label: string },
} = {
  linkedin: {
    href: 'https://www.linkedin.com/company/primary/',
    label: 'Primary on LinkedIn',
  },
  x: {
    href: 'https://x.com/PrimaryAI',
    label: 'Primary on X',
  },
};

export const mapLabelToSidebarList = (items: string[]) =>
  items.map((item) => ({
    label: item,
    id: item
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9-]/g, ''),
  }));
